<template>
    <Layout>
        <div slot="main" class="home-bg">
            <nav class="back-nav">
                <div class="back-icon" @click="goBack">
                    <img :src="back" alt="">
                </div>
            </nav>
            <div class="block locale-block">
                <div id="gmap">

                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import backSrc from '@/style/image/back.png';
import Layout from '@/views/Layout.vue';
import router from '@/router';

export default {
    name: 'home',
    components: {
        Layout,
    },
    data() {
        return {
            back: backSrc,
            language: window.localStorage.getItem('show-lang') === 'cn' ? 'zh-CN' : 'en',
            address: '',
        };
    },
    mounted() {
        if (!window.google || !window.google.maps) {
            const url = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCeCPB6UHhdFVuv-dsu1xG9k9jjPe-7rYU&callback=gMapLoaded';
            // const url = `https://google.cn/maps/api/js?region=cn&language=${this.language}&key=AIzaSyBfvKDOECfhHHbU0i4s6QtCnBq26WmbvO8&callback=gMapLoaded`;
            // const url = `https://google.cn/maps/api/js?region=cn&language=${this.language}&key=AIzaSyCeCPB6UHhdFVuv-dsu1xG9k9jjPe-7rYU&callback=gMapLoaded`;
            const jsapi = document.createElement('script');
            jsapi.setAttribute('id', 'g-map-script');
            jsapi.setAttribute('async', 'async');
            jsapi.setAttribute('defer', 'defer');
            jsapi.charset = 'utf-8';
            jsapi.src = url;
            if (document.getElementById('g-map-script')) {
                document.getElementsByTagName('head')[0].removeChild(document.getElementById('g-map-script'));
            }
            document.getElementsByTagName('head')[0].appendChild(jsapi);
        } else {
            this.initGmap();
        }
        const { address } = this.$route.query;
        this.address = address;
        if (!window.gMapLoaded) {
            window.gMapLoaded = () => {
                this.initGmap();
                this.renderMap();
            };
        } else {
            this.initGmap();
            this.renderMap();
        }
    },
    destoryed() {
        this.map = null;
        this.geocoder = null;
        this.point = null;
        this.infowindow = null;
        window.gMapLoaded = null;
    },
    methods: {
        goBack() {
            router.go(-1);
        },
        initGmap() {
            try {
                if (this.map && this.geocoder && this.infowindow) {
                    return;
                }
                this.map = new window.google.maps.Map(document.getElementById('gmap'), {
                    zoom: 17,
                    streetViewControl: false,
                    mapTypeControl: false,
                    fullscreenControl: false,
                });
                this.geocoder = new window.google.maps.Geocoder();
                this.infowindow = new window.google.maps.InfoWindow();
                setTimeout(() => {
                    this.initHide = 'visible';
                }, 1000);
            } catch (e) {
                console.log('no maps');
            }
        },
        renderMap() {
            const { map, infowindow, address } = this;
            let { point } = this;
            try {
                if (point) {
                    point.setMap(null);
                    infowindow.setContent('');
                }
                this.geocoder.geocode({
                    address,
                }, (results, status) => {
                    if (status === 'OK') {
                        if (results[0]) {
                            map.setCenter(results[0].geometry.location);
                            point = new window.google.maps.Marker({
                                position: results[0].geometry.location,
                                map,
                            });
                            this.point = point;
                            infowindow.setContent(address);
                            infowindow.open(map, point);
                            setTimeout(() => {
                                map.setZoom(17);
                            }, 1200);
                        }
                    } else {
                        map.setCenter({ lat: 39.917872, lng: 116.429188 });
                        map.setZoom(2);
                    }
                });
            } catch (e) {
                console.log('no gmap sdk');
            }
        },
    },
};
</script>
<style lang="less" scoped>
    .home-bg {
        background: #F1F1F1;
    }
    .back-nav {
        width: 100%;
        height: 44px;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-content: center;
        position: fixed;
        top: 50px;
        left: 0;
        z-index: 3;
        border-bottom: 1px solid #F1F1F1;
        .back-icon {
            width: 11px;
            height: 17px;
            margin-top: 14px;
            margin-left: 20px;
            z-index: 3;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .strong {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            font-size: 15px;
            color: #4A4A4A;
            text-align: center;
            line-height: 44px;
            font-weight: 500;
        }
    }
    #gmap {
        margin-top: 44px;
        width: 100%;
        height: 573px;
    }
</style>
